import React from "react";
import { Hidden } from "@material-ui/core";

import DesktopViewer from "./ProductImageViewerDesktop";
import MobileViewer from "./ProductImageViewerMobile";

function ImageViewer({ pictureNew, images, product }) {
  const imagesWithNewPicture = pictureNew ? [pictureNew, ...images] : images;
  return (
    <>
      <Hidden implementation="css" mdUp>
        <MobileViewer images={imagesWithNewPicture} product={product} />
      </Hidden>
      <Hidden implementation="css" smDown>
        <DesktopViewer pictureNew={pictureNew} images={images} product={product} />
      </Hidden>
    </>
  );
}

export default ImageViewer;
